const DealInvestors = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/investors');
const Deals = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals');
const DealsCommon = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/common');
const DealsCommonView = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/commonView');
const DealsPreferred = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/preferred');
const DealsPreferredView = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/preferredView');
const DealsDebt = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/debt');
const DealsDebtView = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/debtView');
const DealsWarrant = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/warrant');
const DealsWarrantView = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/deals/warrantView');
const InvestorsProfile = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/investors/profile');
const InvestorsCustodian = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/investors/custodian');
const Prediction = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/prediction');
const PredictionCommon = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/prediction/common');
const PredictionPreferred = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/prediction/preferred');
const PredictionDebt = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/prediction/debt');
const PredictionWarrant = () => import(/* webpackChunkName: "dealCenter" */ '@/pages/dealCenter/prediction/warrant');
export default [
  {
    path: 'dealcenter/investors',
    name: 'Deal Center / Investors',
    component: DealInvestors,
  },
  {
    path: 'dealcenter/deals',
    name: 'Deal Center / Deals',
    component: Deals,
  },
  {
    path: 'dealcenter/deals/common:deal_id?',
    name: 'Deal Center / Deals / Common Deal',
    component: DealsCommon,
  },
  {
    path: 'dealcenter/deals/common/view:deal_id?',
    name: 'Deal Center / Deals / Common Deal View',
    component: DealsCommonView,
  },
  {
    path: 'dealcenter/deals/preferred:deal_id?',
    name: 'Deal Center / Deals / Preferred Deal',
    component: DealsPreferred,
  },
  {
    path: 'dealcenter/deals/preferred/view:deal_id?',
    name: 'Deal Center / Deals / Preferred Deal View',
    component: DealsPreferredView,
  },
  {
    path: 'dealcenter/deals/debt:deal_id?',
    name: 'Deal Center / Deals / Debt Deal',
    component: DealsDebt,
  },
  {
    path: 'dealcenter/deals/debt/view:deal_id?',
    name: 'Deal Center / Deals / Debt Deal View',
    component: DealsDebtView,
  },
  {
    path: 'dealcenter/deals/warrant:deal_id?',
    name: 'Deal Center / Deals / Warrant Exchange Deal',
    component: DealsWarrant,
  },
  {
    path: 'dealcenter/deals/warrant/view:deal_id?',
    name: 'Deal Center / Deals / Warrant Exchange Deal View',
    component: DealsWarrantView,
  },
  {
    path: 'dealcenter/investors/profile:investor_id?/:overall_behavior?',
    name: 'Deal Center / Investors / Profile',
    component: InvestorsProfile,
  },
  {
    path: 'dealcenter/investors/custodian:custodian_id?',
    name: 'Deal Center / Investors / Custodian',
    component: InvestorsCustodian,
  },
  {
    path: 'dealcenter/prediction',
    name: 'Deal Center / Prediction',
    component: Prediction,
  },
  {
    path: 'dealcenter/prediction/common',
    name: 'Deal Center / Prediction / Common',
    component: PredictionCommon,
  },
  {
    path: 'dealcenter/prediction/preferred:prediction_id?',
    name: 'Deal Center / Prediction / Preferred',
    component: PredictionPreferred,
  },
  {
    path: 'dealcenter/prediction/debt',
    name: 'Deal Center / Prediction / Debt',
    component: PredictionDebt,
  },
  {
    path: 'dealcenter/prediction/warrant',
    name: 'Deal Center / Prediction / Warrant Exchange',
    component: PredictionWarrant,
  },
];
